var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconOpportunitiesPerConsumer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#619BF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2809 19.875H14.7184C12.7366 19.875 11.125 21.4875 11.125 23.4684V25.0312C11.125 25.29 11.335 25.5 11.5938 25.5H24.4066C24.6653 25.5 24.8753 25.29 24.8753 25.0312V23.4684C24.8744 21.4875 23.2628 19.875 21.2809 19.875Z",
    fill: "#BED8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 10.5C15.5875 10.5 13.6244 12.4622 13.6244 14.8753C13.6244 17.2884 15.5875 19.2506 17.9997 19.2506C20.4119 19.2506 22.375 17.2884 22.375 14.8753C22.375 12.4622 20.4119 10.5 17.9997 10.5ZM17.7625 14.4066H18.2378C18.9681 14.4066 19.5625 15.0009 19.5625 15.7312C19.5625 16.3884 19.0891 16.9284 18.4685 17.0391V17.5312C18.4685 17.79 18.2585 18 17.9997 18C17.741 18 17.531 17.79 17.531 17.5312V17.0625H16.9056C16.6469 17.0625 16.4369 16.8525 16.4369 16.5938C16.4369 16.335 16.6469 16.125 16.9056 16.125H18.2369C18.4506 16.125 18.6241 15.9506 18.6241 15.7378C18.6241 15.5184 18.4497 15.3441 18.2369 15.3441H17.7616C17.0313 15.3441 16.4369 14.7497 16.4369 14.0194C16.4369 13.3622 16.9103 12.8222 17.531 12.7116V12.2184C17.531 11.9597 17.741 11.7497 17.9997 11.7497C18.2585 11.7497 18.4685 11.9597 18.4685 12.2184V12.6872H19.0938C19.3525 12.6872 19.5625 12.8972 19.5625 13.1559C19.5625 13.4147 19.3525 13.6247 19.0938 13.6247H17.7625C17.5488 13.6247 17.3753 13.7991 17.3753 14.0119C17.3744 14.2322 17.5488 14.4066 17.7625 14.4066Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconOpportunitiesPerConsumer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-opportunities-per-consumer.56c4b842b84da2fa5eaff88bbfd229e0.svg";